export const siteInfo = {
  name: "SCOOP Saint-Louis",
  fullName: "Société Coopérative des Producteurs de Saint-Louis",
  slogan: "Coopérons pour nourrir l'avenir",
  description: "Coopérative agricole de la région de Saint-Louis spécialisée dans la production, transformation, élevage et aquaculture dans la vallée du fleuve Sénégal.",
  email: "contact@scoopsaintlouis.sn",
  phone: "+221 77 658 03 12",
  address: "Quartier Sor, Saint-Louis, Sénégal",
  website: "https://scoopsaintlouis.sn"
}

export const navigationMenu = [
  { name: "Accueil", path: "/" },
  { name: "Qui sommes-nous ?", path: "/qui-sommes-nous" },
  { name: "Nos activités", path: "/nos-activites" },
  { name: "Actualités", path: "/actualites" },
  { name: "Galerie", path: "/galerie" },
  { name: "Partenaires", path: "/partenaires" },
  { name: "Contact", path: "/contact" }
]

export const keyNumbers = [
  {
    number: "2,500",
    label: "Tonnes produites/an",
    icon: "🌾"
  },
  {
    number: "350",
    label: "Membres actifs",
    icon: "👥"
  },
  {
    number: "25",
    label: "Partenariats",
    icon: "🤝"
  },
  {
    number: "15",
    label: "Années d'expérience",
    icon: "📅"
  }
]

// Images authentiques du site officiel SAED (saed.sn) + Élevage sénégalais authentique
export const activities = [
  {
    id: 1,
    title: "Production rizicole",
    description: "Culture intensive de riz irrigué dans les casiers aménagés de la vallée du fleuve Sénégal, suivant les modèles SAED.",
    image: "https://saed.sn/static/assets/images/services/service-1-3.png",
    features: ["Casiers aménagés", "Irrigation moderne", "Riz local de qualité", "Techniques SAED", "Partenariats publics-privés", "Rendements optimisés"]
  },
  {
    id: 2,
    title: "Élevage bovin et zébus",
    description: "Élevage traditionnel et moderne de bovins et zébus dans la région de Saint-Louis, contribuant à plus de 3% du PIB national.",
    image: "https://images.unsplash.com/photo-1500595046743-cd271d694d30?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    features: ["Zébus Gobra", "Bovins N'Dama", "Élevage extensif", "Transhumance", "Amélioration génétique", "Productivité renforcée"]
  },
  {
    id: 3,
    title: "Aménagements hydro-agricoles",
    description: "Développement d'infrastructures d'irrigation et d'aménagement des terres dans le delta du fleuve Sénégal.",
    image: "https://saed.sn/static/assets/images/services/service-2-6.png",
    features: ["Canaux d'irrigation", "Stations de pompage", "Aménagement foncier", "Gestion de l'eau", "Infrastructure moderne", "Drainage contrôlé"]
  },
  {
    id: 4,
    title: "Agriculture familiale",
    description: "Appui aux exploitations agricoles familiales dans les départements de Bakel, Matam et Saint-Louis.",
    image: "https://saed.sn/static/assets/images/services/service-2-5.png",
    features: ["Formations techniques", "Équipements agricoles", "Crédit rural", "Encadrement SAED", "Coopératives locales", "Développement durable"]
  },
  {
    id: 5,
    title: "Agro-pastoralisme",
    description: "Systèmes intégrés agriculture-élevage renforçant la résilience des communautés face aux changements climatiques.",
    image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    features: ["Agriculture-élevage", "Résilience climatique", "Pastoralisme durable", "Services climatiques", "Gestion intégrée", "Adaptation climatique"]
  },
  {
    id: 6,
    title: "Projets de développement",
    description: "Mise en œuvre de projets structurants pour le développement agricole dans la vallée du fleuve.",
    image: "https://saed.sn/static/assets/images/projects/project-2-6.png",
    features: ["Projets AFD", "Partenariats internationaux", "Innovation agricole", "Transfert de technologie", "Financement rural", "Impact social"]
  }
]

export const news = [
  {
    id: 1,
    title: "Programme d'amélioration génétique de l'élevage",
    date: "2024-07-25",
    category: "Élevage",
    excerpt: "Lancement d'un programme d'amélioration génétique pour renforcer la productivité de l'élevage et contribuer au PIB national de plus de 3%.",
    image: "https://images.unsplash.com/photo-1500595046743-cd271d694d30?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    content: "Plus de 44% des ménages sénégalais sont engagés dans l'agriculture, et l'élevage représente une part croissante du secteur primaire..."
  },
  {
    id: 2,
    title: "Visite ministérielle au casier de Bow",
    date: "2024-07-18",
    category: "Visite officielle",
    excerpt: "Le Ministre de l'Agriculture Dr Mabouba Diagne visite le casier rizicole de Bow lors de la campagne de saison sèche chaude 2024.",
    image: "https://saed.sn/static/assets/images/services/service-1-3.png",
    content: "Le casier de Bow d'une superficie de 320 hectares, réalisé grâce au projet APEFAM 2 financé par l'État du Sénégal et l'AFD..."
  },
  {
    id: 3,
    title: "Renforcement résilience agro-pastorale",
    date: "2024-07-20",
    category: "Changement climatique",
    excerpt: "Les agro-pastoralists du Sénégal renforcent leur résilience face au changement climatique grâce aux services climatiques communautaires.",
    image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    content: "Programme de renforcement de la résilience des communautés agro-pastorales avec des services climatiques adaptés..."
  },
  {
    id: 4,
    title: "Plan stratégique de développement SAED",
    date: "2024-07-22",
    category: "Développement",
    excerpt: "Lancement de l'atelier d'élaboration du plan stratégique de développement de la SAED avec le soutien de l'AFD.",
    image: "https://saed.sn/static/assets/images/resources/about-1-1.png",
    content: "Objectif de produire une première version du document du Plan stratégique de développement de la SAED..."
  }
]

export const partners = [
  {
    name: "SAED",
    logo: "/logos/saed.png",
    website: "https://saed.sn",
    type: "Institutionnel"
  },
  {
    name: "AICCRA",
    logo: "/logos/aiccra.png",
    website: "https://aiccra.cgiar.org",
    type: "Recherche"
  },
  {
    name: "AFD",
    logo: "/logos/afd.png", 
    website: "https://afd.fr",
    type: "Financier"
  },
  {
    name: "Ministère Agriculture",
    logo: "/logos/ministere-agriculture.png",
    website: "https://agriculture.gouv.sn",
    type: "Institutionnel"
  },
  {
    name: "SEA Sénégal",
    logo: "/logos/sea-senegal.png",
    website: "https://facebook.com/seasenegalagricultureelevagepeche",
    type: "Service"
  }
]

export const testimonials = [
  {
    name: "Amadou Diallo",
    role: "Producteur de riz - Casier de Bow",
    content: "Grâce aux aménagements SAED et aux formations techniques, nous avons atteint des rendements de 100 sacs à l'hectare sur notre parcelle de 25 hectares. C'est un succès pour notre coopérative.",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80"
  },
  {
    name: "Fatou Sow",
    role: "Éleveuse de zébus - Touba",
    content: "Notre troupeau de zébus Gobra s'est développé grâce aux programmes d'amélioration génétique. L'élevage contribue maintenant significativement aux revenus de notre famille.",
    avatar: "https://images.unsplash.com/photo-1494790108755-2616b5d47db3?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80"
  },
  {
    name: "Moussa Kane",
    role: "Agro-pasteur - Ferlo",
    content: "L'intégration agriculture-élevage nous permet de mieux résister aux variations climatiques. Les services climatiques nous aident à planifier nos activités.",
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80"
  }
] 